import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../services/api';
import { CheckCircle, Loader, Mail } from 'lucide-react';

export default function ForgotPassword() {
  const [email, setEmail]     = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent]       = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSending(true);
    try {
      await authApi.forgotPassword(email.trim().toLowerCase());
    } catch { /* always succeed visually — prevent enumeration */ }
    finally { setSending(false); setSent(true); }
  };

  if (sent) return (
    <div className="login-screen">
      <div className="login-card" style={{ maxWidth: 420, textAlign: 'center' }}>
        <CheckCircle size={44} style={{ color: 'var(--green)', margin: '0 auto 16px' }} />
        <h2 style={{ fontSize: 20, fontWeight: 700, color: 'var(--text)', marginBottom: 10 }}>
          Check your email
        </h2>
        <p style={{ color: 'var(--text-dim)', fontSize: 14, lineHeight: 1.6, marginBottom: 24 }}>
          If <strong style={{ color: 'var(--text)' }}>{email}</strong> is registered,
          you'll receive a password reset link shortly.
          The link is valid for 24 hours.
        </p>
        <p style={{ color: 'var(--text-dim)', fontSize: 13, marginBottom: 20 }}>
          Didn't receive it? Check your spam folder, or{' '}
          <button onClick={() => setSent(false)}
            style={{ background: 'none', border: 'none', color: 'var(--blue)',
                     cursor: 'pointer', fontSize: 13, padding: 0, textDecoration: 'underline' }}>
            try again
          </button>.
        </p>
        <Link to="/login" style={{ fontSize: 13, color: 'var(--text-dim)' }}>
          ← Back to login
        </Link>
      </div>
    </div>
  );

  return (
    <div className="login-screen">
      <div className="login-card" style={{ maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <h1 style={{ fontSize: 28, fontWeight: 800, margin: '0 0 4px', color: 'var(--text)' }}>
            AP21<span style={{ color: 'var(--blue)' }}>→</span>EZY
          </h1>
          <p style={{ fontSize: 13, color: 'var(--text-dim)', margin: 0 }}>Sync Platform</p>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
          <Mail size={18} style={{ color: 'var(--blue)' }} />
          <h2 style={{ fontSize: 18, fontWeight: 700, color: 'var(--text)', margin: 0 }}>
            Forgot your password?
          </h2>
        </div>
        <p style={{ color: 'var(--text-dim)', fontSize: 13, marginBottom: 24, lineHeight: 1.5 }}>
          Enter your email address and we'll send you a link to reset your password.
        </p>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <label className="input-label">Email address</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="input"
              placeholder="you@company.com"
              autoFocus
              required
            />
          </div>
          <button type="submit" disabled={sending || !email.trim()} className="btn btn-primary">
            {sending
              ? <><Loader size={15} className="spin" /> Sending…</>
              : 'Send reset link'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <Link to="/login" style={{ fontSize: 13, color: 'var(--text-dim)' }}>
            ← Back to login
          </Link>
        </div>
      </div>
    </div>
  );
}
